export default {
	personal_website_builder: 'Personal Website Builder',
	successful: 'Successful',
	link_copied: 'Link copied',
	edit_url: 'Edit URL',
	use_own_domain: 'Can I use my own domain name for the website?',
	yes_use_own_domain:
		'Yes. You can use your own domain name for the website. If you wish to<br />use your own domain name, please follow the steps in the',
	following_link: 'following link',
	save: 'Save',
	get_started: 'Get Started',
	welcome_pwb: 'Welcome to your personal website builder!',
	few_steps_closer_launch:
		'You are now just few steps closer to launching yourself to a whole new level. Having your own professional website couldn’t have been easier!',
	choose_subdomain: 'Choose subdomain',
	begin_website_setup_url: "Let's begin by setting up your website's URL",
	can_use_own_domain: 'Can I use my own domain name for the website?',
	update_profile: 'Update Profile',
	update_profile_desc:
		'When people land on your site, you want them to understand who you are, what you do, and what inspires you.',
	avatar: 'Avatar',
	story: 'Story',
	short_bio: 'Write a short bio here...',
	your_social_information: 'Your social information',
	your_social_information_desc:
		'Provide information to let people know why and how to contact you including all your Social Media footprints.',
	contact: 'Contact',
	phone_number: 'Phone Number',
	social: 'Social',
	customize_seo_desc:
		'Customize the Search Engine Optimization (SEO) settings for your web pages to help your website get found online.',
	page_title: 'Page Title',
	user_financial_planning: '{userName} - Financial Planning',
	describe_web_page_business: 'Describe your web page and business in 55-60 characters.',
	page_description: 'Page Description',
	precise_desc_awesome_page: 'Here is a precise description of my awesome webpage.',
	page_summary_desc: 'Summarize the content found on this web page in 155-160 characters.',
	financial_planner: 'Financial Planner',
	keywords: 'Keywords',
	keywords_desc:
		'Add relevant keywords to the page separated by commas. The more specific, the better.',
	snippet_image: 'Snippet Image',
	image_not_appearing: 'My image is not appearing on Social Media?',
	favicon: 'Favicon',
	achievements: 'Achievements',
	achievements_desc: 'Raise your Personal Branding by adding your Professional Achievements.',
	example: 'example',
	title: 'Title',
	from_to_date: '{fromYear} to {toYear}',
	description: 'Description',
	add_item: 'Add Item',
	services: 'Services',
	services_desc: 'Highlight some of the Professional Services that you provide for your clients.',
	will_writing: 'Will Writing',
	will_writing_desc: 'I am a Certified Estate Planner ...',
	next: 'Next',
	previous: 'Previous',
	submit: 'Submit',
	undo_last_action: 'Undo last action',
	redo_last_action: 'Redo last action',
	styles: 'Styles',
	styles_desc:
		'You can customise the look and feel of the website in this section. The changes here will affect the entire website.',
	primary_color: 'Primary Color',
	header: 'Header',
	body: 'Body',
	seo_desc:
		'This is how your page will look like when on Google Search, Social Media or Whatsapp.',
	full_preview: 'Full Preview',
	your_seo_preview: 'Your SEO Preview',
	seo_preview_desc:
		'Your website can be preview in two ways: how it will appear in search results, and how it will appear when someone is sharing your website to their friends.',
	search_engine: 'Search Engine',
	social_media: 'Social Media',
	customise_seo_desc:
		'Customize the Search Engine Optimization (SEO) settings for your web pages to help your website get found online.',
	confirm: 'Confirm',
	settings: 'Settings',
	settings_desc:
		'You can switch to another template or reset the template to the default values.',
	choose_new_template: 'Choose New Template',
	reset_template: 'Reset Template',
	disclaimers: 'Disclaimers',
	other_settings: 'Other Settings',
	unpublish: 'Unpublish',
	are_you_sure: 'Are you sure?',
	are_you_sure_desc:
		'Are you sure you want to switch to a new template? Changes made to the current template will be saved and can be reloaded the next time you switch to the template.',
	yes: 'Yes',
	change_now: 'Change Now',
	reset_template_confirm_msg:
		'Once you reset, all of your saved changes will be gone and cannot be recovered.',
	yes_reset_now: 'Yes. Reset Now.',
	disclaimer_settings: 'Disclaimer Settings',
	content_form_disclaimer: 'Content form disclaimer',
	content_form_disclaimer_desc:
		'By checking on the box, you are deemed to consent to the collection, use and disclosure of your personal data by FIRSTNAMELASTNAME to GoalsMapper for the following purposes:',
	perform_holistic_review: 'Perform a holistic review of your financial portfolio',
	send_marketing_information: 'Send you marketing information about products and services',
	comply_laws:
		'Comply with any applicable laws, regulations, codes of practice, guidelines, or rules, or to assist in law enforcement and investigations conducted by any government and/or regulatory authority',
	notify_promotions:
		'Notify you of any marketing events, initiatives and promotions, lucky draws, membership and rewards schemes and other promotions',
	contact_information_submit_message:
		'Your contact details will be submitted to FIRSTNAMELASTNAME via GoalsMapper platform. GoalsMapper is a third party financial planning software designed to create a collaborative financial planning experience between the financial consultants and their clients.',
	proceed_if_agree_contact: 'Please proceed if you agree to be contacted for the purposes above.',
	widget_disclaimer: 'Widget Disclaimer',
	consent_personal_data_collection:
		'I consent to the collection, use and disclosure of my personal data for the following purposes:',
	consent_personal_data_collection_1:
		'a. performing obligations in the course of or in connection with our provision of the goods and/or services requested by you;',
	consent_personal_data_collection_2:
		'b. sending you marketing information about our goods or services including notifying you of our marketing events, initiatives and promotions, lucky draws, membership and rewards schemes and other promotions;',
	consent_personal_data_collection_3:
		'c. complying with any applicable laws, regulations, codes of practice, guidelines, or rules, or to assist in law enforcement and investigations conducted by any governmental and/or regulatory authority;',
	consent_personal_data_collection_4:
		'd. any other purposes for which you have provided the information;',
	clear_content: 'Clear content',
	reset_disclaimer: 'Reset default disclaimer',
	facebook_pixel_desc:
		'The Facebook pixel is code that you place on your website. It collects data that helps you track conversions from Facebook ads, optimize ads, build targeted audiences for future ads, and remarket to people who have already taken some kind of action on your website.',
	facebook_pixel_id: 'Facebook Pixel Id',
	how_to_get_fb_pixel: 'How do I get the Facebook Pixel?',
	fb_pixel_desc: 'The pixel code should be added to the head section of the website.',
	add_recaptch_here: 'Add Recaptcha key here.',
	how_to_get_recaptcha: 'How to get the Recaptcha Key?',
	add_google_analytics: 'Add Google Analytics here.',
	unpublish_your_website: 'Unpublish your Website',
	confirm_unpublish_website: 'Are you sure you want to unpublish your site?',
	unpublish_website_msg:
		'Are you sure you want to unpublish your site? <br />The url {fullWebsiteURL} will no longer be accessible once you unpublish your website.',
	yes_unpublish_now: 'Yes. Unpublish Now.',
	sections: 'Sections',
	drag_rearrange_sections: 'Drag and rearrange the order of your website’s sections',
	my_story: 'My Story',
	my_services: 'My Services',
	my_achievements: 'My Achievements',
	videos: 'Videos',
	ebook: 'Ebook',
	testimonials: 'Testimonials',
	tools: 'Tools',
	edit: 'Edit',
	configure: 'Configure',
	background: 'Background',
	configure_intro_page: 'Configure Introduction Page',
	download_ebook: 'Download eBook',
	preview: 'Preview',
	desktop: 'Desktop',
	tablet: 'Tablet',
	mobile: 'Mobile',
	status: 'Status',
	blank: 'Blank',
	launch: 'Launch!',
	auto_save: 'Changes are auto saved',
	published: 'Published',
	published_on: 'Published on',
	last_updated_on: 'Last updated on',
	researcher_author_speaker: 'Researcher,<br />Author & Speaker',
	tagline: 'Making a Difference<br /> to your<br /> Financial Future',
	tagline_desc:
		'My goal is to help my clients achieve their goals and financial freedom and build a professional and trusted relationship. ',
	about: 'ABOUT',
	about_body:
		'Attracted by the fulfilment of a meaningful career, I joined the financial services industry to make a difference to people’s lives. As a strong advocate in financial planning, many clients has changed their perspective towards managing their finances after meeting me.',
	service_subtitle:
		'My job today is to help you with three main functions of financial planning – Save, Protect & Grow your money!',
	service_body1:
		'The first step to good money management is to adopt the right savings habits. In the consumerist environment today, many would prefer spending money on a branded watch rather than saving for rainy days or for their financial goal. Find out from me how you can take the small step towards saving for your financial goals.',
	protect: 'Protect',
	service_body2:
		'Some people mistakenly measured insurance coverage by the number of policies they have, but the reality is that having many insurance policies does not equate to having sufficient coverage. Find out from me if you are really adequately covered, or grossly under insured.',
	grow: 'Grow',
	service_body3:
		'The power of compounding is real and the earlier you start, the better it is. Some people choose to avoid risk by keeping savings in the bank, thinking it’s a safe haven. However, if you consider inflation, savings in the bank is the place that you definitely lose the value of your money. Find out from me how you can grow your investments while managing the risk through diversification.',
	yours_free: 'YOURS FREE:',
	ebook_desc:
		'Simple financial concepts that everyone can adopt to improve their financial situation immediately!',
	download_ebook_btn: 'Download your free Ebook',
	download_ebook_subtitle:
		'PS: This book serves to provide the tips and strategies on financial planning, but most importantly you need to apply and practice these strategies. Happy reading!',
	financial_calculators: 'Financial Calculators',
	financial_calculator: 'Financial Calculator',
	financial_calculators_short_desc:
		'Here, You can change the way your widgets appear on the website',
	financial_calculators_desc:
		'You can change the way your widgets appear on the website by editing the settings below.',
	header_color: 'Header Color',
	text_color: 'Text Color',
	button_text_color: 'Button Text Color',
	button_background_color: 'Button Background Color',
	widget: 'Widget',
	widget_desc:
		'Interactive financial calculators that can attract more leads. It can help your potential clients get a quick understanding on how much something may cost them and how much they need to save/invest for it. At the end of the steps, they will be prompted to get in touch with you for a consultation session. Leads will be sent to your account’s email.',
	add_widgets: 'Add Widgets',
	choose_widgets: 'Choose widgets to be added to your website.',
	coming_soon: 'Coming Soon!',
	education_calculator: 'Education Calculator',
	education_calculator_desc: 'See how much children education can cost locally and abroad',
	retirement_calculator: 'Retirement Calculator',
	retirement_calculator_desc: 'See how much you need for your retirement',
	insurance_calculator: 'Insurance Calculator',
	insurance_calculator_desc: 'See how far your insurance is covering you right now',
	message_successfully_sent: 'Your message has been successfully sent',
	name: 'Name',
	name_required: 'Name is required',
	message: 'Message',
	message_here: 'Message Here',
	footer_text:
		'The information provided on this website is general in nature and does not constitute financial advice. The website can change without prior notice and does not guarantee the accuracy of information, including information provided by third parties, at any particular time.<br /><br /> Individuals must not rely on this information to make a financial or investment decision. Before making any decision, we recommend you to consult a professional financial consultant to take into account your particular investment objectives, financial situation and individual needs. <br /><br />The owner of this website does not give any warranty as to the accuracy, reliability or completeness of information which is contained in this website. The owner of this website do not accept any liability for any error or omission on this website or for any resulting loss or damage suffered by the recipient or any other person.<br /><br /> Unless otherwise specified, the information provided on this website is copyrighted. You may not alter or modify this information in any way, including the removal of this copyright notice.',
	main: 'Main',
	customize_tagline: 'Here, you can customise appearance of the tagline.',
	customize_tagline_desc:
		'You can change the way your tagline appear on the website by editing the settings below.',
	tagline_color: 'Tagline Color',
	story_desc: 'Here, you can change the way your information appear on the website.',
	story_settings_desc:
		'You can change the way your information appear on the website by editing the settings below.',
	your_services: 'Your Services',
	your_services_desc:
		'You can change the way your services appear on the website by editing the settings below.',
	my_achievements_desc:
		'Set yourself apart from your competition and showcase your Professional Achievements.',
	your_achievements: 'Your Achievements',
	your_achievements_desc:
		'You can change the way your achievements appear on the website by editing the settings below.',
	videos_desc: 'Here, you can change the way your videos appear on the website.',
	your_videos_desc:
		'You can change the way your videos appear on the website by editing the settings below.',
	video: 'Video',
	ebook_intro_page: 'eBook Introduction Page!',
	ebook_intro_page_desc:
		'Create an eBook Introduction Page to help readers know about you, your credentials and experience and how you can help them with their Financial Needs.',
	testimonials_desc:
		'Customer testimonials add content to your site, and they help you to look more valuable and more believable to those who are exploring it for the first time.',
	your_testimonials: 'Your Testimonials',
	your_testimonials_desc:
		'You can change the way your testimonials appear on the website by editing the settings below.<br /> Only <b>Featured</b> testimonials will be included in section.',
	height: 'Height',
	testimonial_style: 'Testimonial Style',
	style: 'Style',
	contact_desc:
		'Include links to your Social Media Pages and create a personal branding for yourself.',
	receiving_email: 'Receiving email *',
	contact_number: 'Contact Number',
	social_media_links: 'Social Media Links',
	whatsapp_desc: 'e.g. +6501234567 or https://wa.me/6501234567',
	telegram_desc: 'e.g. chanxing or https://telegram.me/chanxing',
	appearance: 'Appearance',
	social_media_icons_color: 'Social Media Icons Color',
	button_label: 'Button Label',
	set_background: 'Set Background',
	layout: 'Layout',
	begin: 'Begin',
	richard_tan_testimonial:
		'I am absolutely delighted with your service. It is really refreshing to work with a financial adviser who is truly interested in their client’s needs, circumstances and preferences. What really impressed me was the way you took the time to get a feeling for where I was at, your depth of knowledge, lateral thinking and your common sense approach. Your professional, ethical and caring demeanour elicits my trust and respect and I gladly recommend your services whenever possible.',
	lily_jacob_testimonial:
		'I was really impressed with the way Lisa use the software to map out my finances and how various scenarios can affect my financial health. This is the way Financial Planning should be. I highly recommend her services.',
	sam_ng_testimonial:
		"The session with Lisa was 'Wow'. It made me realise my financial gaps and things that I have never thought of. The way I can see my shortfall and how my dependants can be affected by various situations really strike me.",
	clinic_assistant: 'Clinic Assistant',
	army_officer: 'Army Officer',
	it_specialist: 'IT Specialist',
	plan: 'Plan',
	service_body4:
		"Plan out your Financial Future today! Get to understand your financial goals better, and most importantly, setting the right financial budget for the goals you want in life. Everyone of us wants to have the best things in life, but realisticaly, we can't have everything. Setting the right financial goals first is the key to making right financial decisions for your life.",
	select: 'Select',
	e_g: 'e.g.',
	ebook_personal_branding: 'Create your own personal branding ebook.',
	button: 'Button',
	popup: 'Popup',
	use_goalsmapper_ebook: 'Use GoalsMapper Ebook',
	customize_ebook_intro_page: 'Customize eBook Introduction Page',
	upload_image: 'Upload Image',
	change_image: 'Change Image',
	browse_unsplash: 'Browse Image from Unsplash',
	set_color: 'Set Color',
	expected_image_size: 'Expected image size',
	ok: 'Ok',
	search: 'Search',
	columns: 'Columns',
	save_successful: 'Save Successful',
	entity_saved: 'Your {entity} has been saved',
	entity_saved_not_launched: 'Your {entity} has been saved, but not yet launched.',
	publish: 'Publish',
	to_publish_latest_changes: 'to publish latest changes',
	to_make_it_visible: 'to make it visible for everybody to see',
	click: 'Click',
	website: 'website',
	report_cover: 'report cover',
	report: 'report',
	ebook_intro: 'ebook intro',
	preview_ebook: 'Preview eBook',
	ebook_intro_text_left:
		"Lisa Tan joined the financial advisory practice in 2007. She strongly believes in the ability of financial planning to make a difference in people's lives. This belief and her passion have helped her to achieve remarkable results in her journey as a financial consultant so far.<br /><br />Shortly after joining, she amassed a large clientele of professionals, expatriates and overseas clients. To date, she has provided financial advice to clients from more than 20 countries.<br /><br />In her pursuit of knowledge to serve her clients better, she has also attained the designation of ChFC /S and CLU /S by The American College of Financial Services, and also holds the AEPP designation awarded by Estate Planning Practitioners Ltd.",
	ebook_intro_text_right:
		'Leveraging her years of experience, Lisa created a goals-centric, financial planning methodology known as GoalsMapping. She uses this approach to advise her clients, and has received numerous positive testimonials on how her planning methodology has been able to help her clients achieve their various financial goals.<br /><br />In 2015, she co-founded SuperFinTech, a company that has a vision to redefine financial planning.<br /><br />In 2016, she achieved the prestigious Court of the Table award and was ranked as the top 1% producer in his firm. And in 2018, she successfully completed her MDRT Life Member just 10 years after joining the financial advisory industry.',
	goals: 'Goals',
	mapping: 'Mapping',
	what_is_goalsmapping: 'What is {GOALS}{MAPPING}',
	what_is_gm_desc:
		'{GOALS}{MAPPING} is a process that was created to help people develop a well thought-out financial plan that is able to accommodate many different financial goals and scenarios before arriving at an optimal solution. Specifically, the {GOALS}{MAPPING} process requires you to list down all your financial goals, and to test it against different scenarios to ensure that you are able to achieve all your financial goals using different instruments – from bank savings and life insurance to other investment tools. In this book, we explore the different models behind {GOALS}{MAPPING}. It consists of simple financial concepts that everyone can adopt to improve their financial situation immediately',
	gm_disclaimer_block:
		'GoalsMapper is a third party financial planning software for financial consultants. The above financial consultant is a user of GoalsMapper and not a representative of GoalsMapper Pte Ltd.',
	add_header_text: 'Add Header Text',
	add_body_text: 'Add Body Text',
	add_image: 'Add Image',
	elements: 'Elements',
	intro_page_editor: 'Introduction Page Editor',
	ebook_unpublish_message:
		'Are you sure you want to unpublish your {entityCover}? <br /> Your personalised {entityCover} will no longer be accessible once it is unpublished.',
	ebook_template_all_types: 'This applies to all {entity} types.',
	mobile_required: 'Mobile is required',
	financial_planning_ebook: 'Financial Planning Ebook',
	financial_planning_ebook_desc:
		'Fill out your information and get FREE Financial Planning Ebook',
	email: 'Email',
	email_required: 'Email is required and must be valid',
	check_box_required: 'Please check this box if you want to proceed',
	i_am_lisa: 'I am Lisa',
	hello_i_am: 'Hello I am FIRSTNAME LASTNAME',
	what_happy_clients_say: 'What Happy Clients Say',
	contact_me: 'Contact Me',
	personal_wealth_manager: 'Personal Wealth Manager',
	tagline_no_br: 'Making a Difference to your Financial Future',
	lets_talk: "Let's Talk",
	drop_a_message: 'Drop a message and get a free appointment with me.',
	financial_specialist: 'Financial Specialist',
	phone: 'Phone',
	customise_seo: 'Customise SEO',
	remove: 'Remove',
	launch_successful: 'Launch Successful',
	congratulations_launched: 'Congratulations, your {entity} has been launched!',
	congratulations_published: 'Congratulations, your {entity} has been published!',
	introduction_page: 'introduction page',
	report_editor: 'report editor',
	you_can_customize_section:
		'You can customise the look of the {entityReportEbook} in this section.',
	settings_updated: 'Settings updated',
	contact_form_disclaimer: 'Contact Form Disclaimer',
	preview_staging_environment_message:
		"You can't send contact form in preview or staging environment",
	message_check_email_download_link: 'Please check your email for eBook download link.',
	achievement1_title: 'Top Rookie',
	achievement1_position: 'Associate',
	achievement1_description:
		'I started my financial advisory career after spending 4 years in the corporate world. I felt the need to make a change and do something that is meaningful.',
	achievement2_title: 'Million Dollar Round Table (MDRT)',
	achievement2_position: 'Financial Services Manager',
	achievement2_description:
		'I was thrilled when I achieved the MDRT for the first year. It is not so much the award that is valuable but the impact I felt when I see my clients achieving their goals.',
	achievement3_title: 'Court of the Table (COT)',
	achievement3_position: 'Financial Services Manager',
	achievement3_description:
		'It was surreal when I got my first COT and helps to drive my passion to continue helping clients achieve their goals.',
	achievement4_title: 'Chartered Financial Planner (CFP)',
	achievement5_title: 'Chartered Financial Analyst (CFA)',
	achievement6_title: 'International Dragon Awards (IDA)',
	uploading: 'Uploading...',
	compressing: 'Compressing...',
	navigation_button_color: 'Navigation Button Color',
	navigation_button_color_tooltip:
		'Refers to the colour of the Arrow buttons (to navigate to the left and right)',
};
